import React, { useState } from 'react';
import clamp from "lodash-es/clamp";

const MIN_VALUE = 0;
const MAX_VALUE = 999;

function formatValue(numValue) {
    return clamp(numValue, MIN_VALUE, MAX_VALUE);
}

function QuantityField({ id }) {
    const [ value, setValue ] = useState(1);
    
    function onChange(e) {
        const numValue = Number(e.target.value);
        
        setValue(formatValue(numValue));
    }

    function onClickSubtract(e) {
        setValue(prev => formatValue(prev - 1));
    }

    function onClickAdd(e) {
        setValue(prev => formatValue(prev + 1));
    }
    
    return (
        <div className="product-detail__quantity-wrapper">
            <button onClick={onClickSubtract}
                    className="product-detail__quantity-subtract">
                <svg xmlns="http://www.w3.org/2000/svg"
                     width="1em"
                     height="1em"
                     fill="none"
                     stroke="currentColor"
                     viewBox="0 0 512 512"
                     aria-hidden="true"
                     className="product-detail__icon-subtract">
                    <path strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="32"
                          d="M400 256H112"/>
                </svg>
            </button>
            <input id={id}
                   type="number"
                   inputMode="numeric"
                   value={value}
                   min={MIN_VALUE}
                   max={MAX_VALUE}
                   maxLength="3"
                   data-buy-quantity-input=""
                   onChange={onChange}
                   className="product-detail__quantity-input"/>
            <button onClick={onClickAdd}
                    className="product-detail__quantity-add">
                <svg xmlns="http://www.w3.org/2000/svg"
                     width="1em"
                     height="1em"
                     fill="none"
                     stroke="currentColor"
                     viewBox="0 0 512 512"
                     aria-hidden="true"
                     className="product-detail__icon-add">
                    <path strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="32"
                          d="M256 112v288m144-144H112" />
                </svg>
            </button>
        </div>
    );
}

export default QuantityField;
